




import {Component, Vue} from 'vue-property-decorator';
import DashboardWings from "@/components/Dashboard/DashboardWings.vue";
import {Action, Getter} from "vuex-class";

@Component({components: {DashboardWings}})
export default class Dashboard extends Vue {
  @Getter("systemSettings") systemSettingsResponse: any;
  @Action("getSystemSettings") actionGetSystemSettings: any;
  private maxWidgetNum: number = 0;

  async created() {
    await this.actionGetSystemSettings();
    await this.getMaxWidgetNum();
  }

  getMaxWidgetNum() {
    this.maxWidgetNum = Number(this.systemSettingsResponse.find((e: any) => e.name == 'MAX_WIDGETS_NUM')?.value || 30);
  }
};
